export default ({ request }) => ({
  /**
     * 保存-修改告警配置
     * @param data
     * @returns {*}
     * @constructor
     */
  SYS_ALERT_SAVE (data = {}) {
    // 接口请求
    return request({
      url: '/api/basic/notice/config/',
      method: 'POST',
      data
    })
  },
  /**
   * 获取分享信息
   * @param data
   * @returns {*}
   * @constructor
   */
  SYS_SHARE_INFO (params = {}) {
    // 接口请求
    return request({
      url: '/sign/url',
      method: 'GET',
      params
    })
  }
})

